import { api } from "@/lib/api";

export const listActivities = (params = {}) => api.get("/activities", { params }).then((r) => r.data);
export const createActivity = (payload) => api.post("/activities", payload).then((r) => r.data);
export const updateActivity = (id, payload) => api.patch(`/activities/${id}`, payload).then((r) => r.data);
export const deleteActivity = (id) => api.delete(`/activities/${id}`).then((r) => r.data);
export const getPipelineAnalytics = (params = {}) => api.get("/analytics/pipeline", { params }).then((r) => r.data);
export const listUsers = () => api.get("/users").then((r) => r.data);
